import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { MembershipService } from 'app/core/services/membership.service';
import { QuestionnaireModel } from 'app/models/questionnaire.model';
import { SessionModel } from 'app/models/session.model';
import { TokenPropertyModel } from 'app/models/token-property.model';
import { QuestionnaireService } from 'app/services/questionnaire.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-questionnaires',
  templateUrl: './questionnaires.component.html',
  styleUrls: ['./questionnaires.component.scss']
})
export class QuestionnairesComponent extends NexusComponent implements OnDestroy {

  public session: SessionModel = null;
  questionnaires_model: Array<QuestionnaireModel> = new Array<QuestionnaireModel>();
  private property_change_subscription: Subscription;
  constructor(private route: ActivatedRoute, private router: Router, private membership: MembershipService,
    private questionnaires_service: QuestionnaireService) {
    super();
    this.event_service.on('session-start', (model) => {
      this.session = model;
    });
    this.event_service.on('session-end', () => {
      this.session = null;
    });
  }

  ngOnInit(): void {
    this.membership.GetSession().subscribe(
      data => {
        this.session = data;
        if(this.session)
          {
            if(this.session.current_property?.id!=null){
              this.load_questionnaires(this.session.current_property?.id);
            }
          }

      },
      error => {
        this.session = null;
      });

     this.property_change_subscription= this.membership.current_property$.subscribe((model: TokenPropertyModel)=>{
        if(model?.id!=null){
          this.load_questionnaires(model?.id);
        }
      });

  }

  load_questionnaires(property_id: string){
    this.StartSpinner('app-questionnaires');
    this.questionnaires_service.GetQuestionnaires(property_id).subscribe(
      data => {
        this.questionnaires_model = data;
        this.StopSpinner('app-questionnaires');
      },
      err => {
        this.StopSpinner('app-questionnaires');
        this.router.navigate(['/dashboard']);
      });
  }
  ngOnDestroy() {
    if (this.property_change_subscription) {
      this.property_change_subscription.unsubscribe();
    }
  }


}
